import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export const TabBorder = ({ className }) => {
    return (_jsxs(Root, { className: className, children: [_jsxs(SvgStyled, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 130 2", fill: "none", children: [_jsx("path", { d: "M1.80437 0.473227C2.16548 0.16767 2.62321 0 3.09625 0H126.904C127.377 0 127.835 0.16767 128.196 0.473227L130 2H0L1.80437 0.473227Z", fill: "url(#paint0_radial_5319_7407)" }), _jsx("defs", { children: _jsxs("radialGradient", { id: "paint0_radial_5319_7407", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(4.94781e-06 19) rotate(-9.40514) scale(131.771 122.199)", children: [_jsx("stop", { stopColor: "#53C1FF" }), _jsx("stop", { offset: "1", stopColor: "#0066FF" })] }) })] }), _jsx(ShadowWrapper, { children: _jsx(Shadow, {}) })] }));
};
const Root = styled.div ``;
const SvgStyled = styled.svg `
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
`;
const ShadowWrapper = styled.div `
  position: absolute;
  bottom: 0;
  left: 0;
  height: 10px;
  width: 100%;
  overflow: hidden;
`;
const Shadow = styled.div `
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 20px;
  border-radius: 270px;
  opacity: 0.5;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #68c9ff 0%,
    rgba(0, 102, 255, 0.5) 49.76%,
    rgba(0, 102, 255, 0.18) 78.92%,
    rgba(0, 102, 255, 0) 100%
  );
`;
//# sourceMappingURL=tab-border.js.map